// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"f94780df","238":"655a818a","376":"fc206864","727":"4362e7b6"}[chunkId] + ".chunk.css";
};